import { AnnouncementFromBackend } from 'app/api/services/live/schedule/types';

import { NAMESPACE_LIVE } from 'app/constants/Context';
import { getPrefixByNamespace } from 'app/modules/Navigation/utils';
import { BreadcrumbType } from 'app/redux/betting-presentation/grid/constants';

export const getBreadcrumbsByMatch = (match: AnnouncementFromBackend) => {
  const {
    tournamentStageId,
    tournamentId,
    tournamentUnionId,
    sportId,
    sportName,
    tournamentUnionName,
    tournamentName,
    tournamentStageName,
  } = match;

  const pathname = getPrefixByNamespace(NAMESPACE_LIVE);

  return [
    {
      name: sportName,
      type: BreadcrumbType.SPORT,
      pathname,
      sportId,
    },
    {
      name: tournamentUnionName,
      type: BreadcrumbType.UNION,
      pathname,
      sportId,
      tournamentUnionId,
    },
    {
      name: tournamentName,
      type: BreadcrumbType.TOURNAMENT,
      pathname,
      sportId,
      tournamentUnionId,
      tournamentId,
    },
    {
      name: tournamentStageName,
      type: BreadcrumbType.STAGE,
      pathname,
      sportId,
      tournamentUnionId,
      tournamentId,
      tournamentStageId,
    },
  ];
};
